import React, { ReactNode } from "react";
import styled from "@emotion/styled";

import { HeaderToolbar } from "../core/HeaderToolbar";
import { MainColumn } from "../core/BodyLayout";
import { useQuickSilverClickLoader } from "src/test/quickSilver/helpers/useQuickSilverClickLoader";
import { NoomLogo } from "../Logo";

const Content = styled(MainColumn)`
  display: grid;
  // Paired 1fr ensures that the logo is centered
  grid-template-columns: 1fr auto 1fr;
  align-items: center;

  height: 48px;
`;

export function Header({
  pill = true,
  children,
  className,
}: {
  pill?: boolean;
  children?: ReactNode;
  className?: string;
}) {
  const onClickQuickSilverLoader = useQuickSilverClickLoader();
  return (
    <HeaderToolbar className={className}>
      <Content>
        {children}
        <NoomLogo
          pill={pill}
          css={{ height: 19, margin: 14, gridColumn: 2, gridRow: 1 }}
          onSecretClick={onClickQuickSilverLoader} // onClick used for debug purposes to load quicksilver
        />
      </Content>
    </HeaderToolbar>
  );
}
